import { z } from 'zod';

/** Общие примитивы схем модулей. Схем адресов здесь нет — они в файлах модулей. */
export const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Дата в формате ГГГГ-ММ-ДД');
